<div class="breadcrumb-container">
    <ng-container *ngFor="let item of currentTrail">
        <div [class.clickable]="getUrl(item)" (click)="navigate(item)" [class.current-breadcrumb-item]="isLastItem(item)">
            {{getName(item)}}
        </div>
        <div class="breadcrumb-arrow-wrapper" *ngIf="!isLastItem(item)">
            <img src="assets/icons/solid-arrow.svg" class="breadcrumb-arrow">
        </div>
    </ng-container>
</div>
